<div class="login-selection-modal">
  <div class="login-modal-header">
    <h2>Login to your account</h2>
    <!-- <button type="button" (click)="closeModal()">×</button> -->
  </div>

  <div class="login-modal-body">
    <button class="sign-in-btn" (click)="signIn()">Sign In</button>

    <button class="guest-btn" (click)="continueAsGuest()">
      Continue as guest
    </button>

    <button class="register-btn" (click)="register()">
      Register as new user
    </button>
  </div>
</div>
